const Colors = {
  main: process.env.REACT_APP_TRANSITAR_COLOR === 'true' ? '#00A194' : '#e68301',
  secundary: process.env.REACT_APP_TRANSITAR_COLOR === 'true' ? '#37b3a9' : '#f3b70b',
  tertiary: '#404040',
  hoverWhite: '#fffdf5',
  hoverMain: process.env.REACT_APP_TRANSITAR_COLOR === 'true' ? '#008075' : '#bf6800',
  white: '#fff',
  black: '#272829',
  secundary_translucent: process.env.REACT_APP_TRANSITAR_COLOR === 'true' ? "#54a8a27f" : "#f3b70b7f",
  cyan:"#3AC9B0",
}

// SASS

export default Colors;
